/**
 * @generated SignedSource<<fb3e2414eec61466a55585911fa7a34d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type StoreAdminScreenQuery$variables = Record<PropertyKey, never>;
export type StoreAdminScreenQuery$data = {
  readonly store: {
    readonly KPIS: ReadonlyArray<{
      readonly id: string;
    }> | null;
    readonly allTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly calendars: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly dashboards: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly defaultTodoCategory: {
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly title: string;
    } | null;
    readonly id: string;
    readonly myRole: Roles;
    readonly name: string;
    readonly screenCount: number | null;
    readonly todoCategories: ReadonlyArray<{
      readonly id: string;
      readonly title: string;
    }>;
    readonly topics: ReadonlyArray<{
      readonly __typename: "StoreTopic";
    }> | null;
    readonly " $fragmentSpreads": FragmentRefs<"StoreAdminScreenUsersItem_Store" | "useHasFeatureInTier_Store">;
  };
};
export type StoreAdminScreenQuery = {
  response: StoreAdminScreenQuery$data;
  variables: StoreAdminScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "myRole",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "defaultTodoCategory",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v0/*: any*/)
],
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "includeArchived",
      "value": false
    }
  ],
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "allTeams",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": "allTeams(includeArchived:false)"
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "dashboards",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreCalendar",
  "kind": "LinkedField",
  "name": "calendars",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "todoCategories",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "screenCount",
  "storageKey": null
},
v12 = {
  "alias": "KPIS",
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "KPI"
    }
  ],
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routines",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": "routines(type:\"KPI\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreAdminScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoreAdminScreenUsersItem_Store"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useHasFeatureInTier_Store"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StoreAdminScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "db1065b3d8dbdc3df5b5427c18317fed",
    "id": null,
    "metadata": {},
    "name": "StoreAdminScreenQuery",
    "operationKind": "query",
    "text": "query StoreAdminScreenQuery {\n  store {\n    id\n    name\n    myRole\n    defaultTodoCategory {\n      id\n      title\n      icon\n    }\n    ...StoreAdminScreenUsersItem_Store\n    ...useHasFeatureInTier_Store\n    allTeams(includeArchived: false) {\n      id\n    }\n    dashboards {\n      id\n    }\n    calendars {\n      id\n    }\n    todoCategories {\n      id\n      title\n    }\n    topics {\n      __typename\n      id\n    }\n    screenCount\n    KPIS: routines(type: KPI) {\n      id\n    }\n  }\n}\n\nfragment StoreAdminScreenUsersItem_Store on Store {\n  userCount\n}\n\nfragment useHasFeatureInTier_Store on Store {\n  tier\n}\n"
  }
};
})();

(node as any).hash = "d2fd649859fba39a96c1b622b9fae048";

export default node;
